// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clinical-shell {
  box-sizing: border-box;
  display: flex;
  gap: 16px;
  height: 100vh;
  padding: 16px;
  overflow: hidden;
  background-color: #F8FAFC;
  font-family: var(--font-sans);
  color: var(--header-text-color);
}

.clinical-shell--collapsed {
  --sidebar-width: var(--sidebar-collapsed-width);
}

.clinical-main {
  flex: 1;
  min-width: 0;
  height: calc(100vh - 32px);
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.clinical-main__scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
  position: relative;
  background: #ffffff;
}

@media print {
  .no-print {
    display: none !important;
  }

  .clinical-shell {
    display: block;
    height: auto;
    min-height: 0;
    overflow: visible;
    padding: 0;
    background: #ffffff;
  }

  .clinical-main,
  .clinical-main__scroll {
    height: auto;
    overflow: visible;
    border: none;
    box-shadow: none;
  }
}

/* Legacy class names kept so existing page wrappers still space correctly */
.site-content-layout,
.site-content-collapsed-layout,
.site-layout,
.site-content-layout-transition,
.body-layout {
  margin: 0 !important;
  background: transparent !important;
  min-height: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,4EAA4E;AAC5E;;;;;EAKE,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;AAC1B","sourcesContent":[".clinical-shell {\n  box-sizing: border-box;\n  display: flex;\n  gap: 16px;\n  height: 100vh;\n  padding: 16px;\n  overflow: hidden;\n  background-color: #F8FAFC;\n  font-family: var(--font-sans);\n  color: var(--header-text-color);\n}\n\n.clinical-shell--collapsed {\n  --sidebar-width: var(--sidebar-collapsed-width);\n}\n\n.clinical-main {\n  flex: 1;\n  min-width: 0;\n  height: calc(100vh - 32px);\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.clinical-main__scroll {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  position: relative;\n  background: #ffffff;\n}\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n\n  .clinical-shell {\n    display: block;\n    height: auto;\n    min-height: 0;\n    overflow: visible;\n    padding: 0;\n    background: #ffffff;\n  }\n\n  .clinical-main,\n  .clinical-main__scroll {\n    height: auto;\n    overflow: visible;\n    border: none;\n    box-shadow: none;\n  }\n}\n\n/* Legacy class names kept so existing page wrappers still space correctly */\n.site-content-layout,\n.site-content-collapsed-layout,\n.site-layout,\n.site-content-layout-transition,\n.body-layout {\n  margin: 0 !important;\n  background: transparent !important;\n  min-height: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
